<template>
  <div v-if="store.loaded" class="container">
    <div :class="['media', {'mobile-media': store.showMobile}]">
      <div :class="{'mobile-top-block': store.showMobile}">
        <h1 v-html="item?.title"/>
        <div v-if="item?.desc?.length" class="description">
          {{ item?.desc }}
        </div>
        <div class="video">
          <iframe
            v-if="isVisible" 
            :src="'https://rutube.ru/play/embed/' + item?.youtubeCode"
            width="100%"
            height="100%"
            frameBorder="0"
            allow="clipboard-write; autoplay"
            webkitAllowFullScreen
            mozallowfullscreen
            allowFullScreen
          />
          <!-- <iframe
            v-if="isVisible" 
            :src="'https://www.youtube.com/embed/' + item?.youtubeCode + '?feature=player_detailpage&rel=0&hd=1&fs=1&showinfo=0'"
            frameborder="0" 
            allowfullscreen
            width="100%"
            height="100%"
            fs="1"
          /> -->
        </div>
      </div>
      <div v-if="item && item.images?.length && !store.showMobile" class="images">
        <template v-for="(image, index) in item.images" :key="image">
          <img 
            :src="'/media/' + image"
            class="images-item"
            @click="
              imageFile = '/media/' + image;
              activeIndex = index;
              numberOfImages = item.images.length;
              imageViewerVisible = true
            "
          >
        </template>
      </div>
      <!-- ================ -->
      <!-- Мобильная версия -->
      <!-- ================ -->
      <template v-if="item && item.images?.length && store.showMobile">
        <flicking
          :options="{
          horizontal: true,
          circular: true,
          bound: false,
          align: 'center',
          inputType: ['pointer'],
          moveType: 'strict',
          autoResize: true,
          adaptive: true,
          panelsPerView: 1,
          defaultIndex: activeIndex
          }"
          @changed="(e) => { activeIndex = e.index }"
        >
          <template v-for="mobileImage in item.images" :key="mobileImage">
            <div class="product_image_container_mobile">
              <img :src="'/media/' + mobileImage" class="product_image_icon_mobile">
            </div>
          </template>
        </flicking>
        <dots-navigation :active-index="activeIndex" :number-of-items="item.images.length"/>
      </template>

    </div>
      <image-viewer
        v-if="imageViewerVisible && item && !store.showMobile"
        :show-mobile="store.showMobile"
        :file="'/media/' + item?.images[activeIndex]" 
        :number-of-images="numberOfImages" 
        :active-index="activeIndex"
        @image-viewer-close="imageViewerVisible = false"
        @image-viewer-prev="if (activeIndex > 0) {--activeIndex};"
        @image-viewer-next="if (activeIndex < item?.images.length-1) {++activeIndex};"
      />
  </div>
  <span v-if="!store.showMobile" @click="goBack" class="link" v-text="'<-- Всё там'"/>
  <span v-else @click="goBack" class="mobile-link"><img src="/images/icon_up.svg" class="mobile-icon"></span>
</template>




<script lang="ts">
import { defineComponent } from 'vue'
import { useMainStore, typeMediaItem } from '../store'
import ImageViewer from '../components/ImageViewer.vue'
import Flicking from '@egjs/vue3-flicking'
import DotsNavigation from '../components/DotsNavigation.vue'

export default defineComponent({
  name: "ViewerBlock",
  components: {
    ImageViewer, Flicking, DotsNavigation
  },
  data() {
    return {
      store: useMainStore(),
      id: -1,
      item: Object as unknown as typeMediaItem | undefined,
      isVisible: true,
      pathFrom: '', // Путь "откуда"
      imageFile: '',
      numberOfImages: 0,
      activeIndex: 0,
      imageViewerVisible: false
    }
  },
  methods: {
    goBack () {
      // Если путь вызова был с одной из страниц сайта,
      // т.е. вызов страницы был не из командной строки (значит есть куда вернуться)
      if (this.store.menu.map(el => el.id).includes(this.pathFrom.slice(1))) { // Удаляем '/' в начале pathFrom, чтобы сравнить с пунктом меню
        this.$router.push({path: this.pathFrom})
      } else {
        this.$router.push({name: 'home'})
      }
    },
    initProject() {
      this.id = Number(this.$route.params.id)
      this.item = this.store.getProject(this.id)
    }
  },
  watch:{
    $route(to, from) {
      if (from.path !== '/project') {
        this.pathFrom = from.path
      }
      if  (this.$route.name === 'project') {
        this.initProject()
        this.isVisible = true
      } else {
        // Удаляем iFrame через секунду чтобы остановить воспроизведение
        // и завершить transition влево без резкого исчезновения плеера на страницы
        setTimeout(() => {this.isVisible = false}, 1100)
      }
    }
  },
  mounted() {
    this.initProject()
  },
})
</script>

<style scoped>

.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.media {
  /* display: grid; */
  width: 70rem;
  max-width: 100%;
  margin: auto;
  padding: 8rem 5rem 5rem 5rem;
}

.video {
  width: 100%;
  aspect-ratio: 16/9;
  margin-top: 3rem;
  border-radius: .5rem;
  overflow: hidden;
}

.description {
  padding-top: 3rem;
  font-size: 1rem;
}

.images {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-height: 100%;
  gap: 1rem;
  padding-top: 2rem;
}

.images-item {
  cursor: pointer;
  max-height: 9rem;
  border-radius: .5rem;
}

.link {
  display: flex;
  align-items: center;
  height: 8rem;
  background-color: #eeeeeeD9;
  padding-right: 2rem;
  position: absolute;
  left: 5rem;
  top: 0;
  pointer-events: all;
  cursor: pointer;
  font-size: 1.8rem;
  transition: all .3s ease-in-out;
}

.link:hover {
  transform: translateX(-2rem);
  padding-right: 4rem;
  transition: all .3s ease-in-out;
}

/* ================ */
/* Мобильная версия */
/* ================ */

.mobile-media {
  padding: 3rem 0 7rem 0;
}

.mobile-top-block {
  padding: 0 1rem;
}

.mobile-link {
  position: fixed;
  pointer-events: all;
  cursor: pointer;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 6rem;
  background-color: #eeeeeeff;
  font-size: 1.8rem;
  transition: all .3s ease-in-out;
  box-shadow: 0 0 50px #8f8f8f59;
  z-index: 1;
}

.mobile-icon {
  height: 3rem;
}

.product_image_container_mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 15rem;
}

.product_image_icon_mobile {
  cursor: pointer;
  /* max-height: -webkit-fill-available; */
  max-height: 100%  ;
  max-width: 90%;
  border-radius: .5rem;
}

/* ================= */
/* Карусель Flicking */
/* ================= */

@import url("@egjs/vue3-flicking/dist/flicking.css");
.flicking-panel {
  width: 90%;
  height: 10rem;
  background-color: beige;
  border-radius: 1rem;
  /* margin: 1rem; */
  font-size: 2rem;
  flex-shrink: 0;
  float: left;
}

.flicking-viewport {
  padding: 2rem;
  transition: height 500ms;
}
</style>
